import { Component } from '@angular/core';
import { FormlyModule } from '@ngx-formly/core';
import { InputFieldType } from '../input-field-type';

@Component({
    selector: 'input-display',
    templateUrl: './input-display.component.html',
    imports: [FormlyModule]
})
export class InputDisplayComponent extends InputFieldType {
  get keyAsString() {
    return this.key as string;
  }
}
